import { render, staticRenderFns } from "./MaterialPreviewDialog.vue?vue&type=template&id=64d0d77a&scoped=true&"
import script from "./MaterialPreviewDialog.vue?vue&type=script&lang=ts&"
export * from "./MaterialPreviewDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MaterialPreviewDialog.vue?vue&type=style&index=0&id=64d0d77a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d0d77a",
  null
  
)

export default component.exports